import { useEffect, useRef, useState } from 'react';
import { usePageViewAnalytics } from '@leagueplatform/analytics';
import { useIntl } from '@leagueplatform/locales';
import { Masonry } from '@leagueplatform/masonry';
import { Modal } from '@leagueplatform/genesis-core';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { useIsAuthenticated } from '@telus-alberta-health-web/shared-module';
import { captureError } from '@leagueplatform/observability';
import { MASONRY } from 'common/constants';
import { PageContentWrapper } from 'components/page-content-wrapper.component';
import { PageHeader } from 'components/page-header/page-header.component';
import { LiveChat } from 'components/live-chat/live-chat.component';
import { ChangeAnnouncementModal } from 'components/modals/change-announcement-modal.component';
import { useChangeAnnouncementModal } from 'hooks/use-change-announcement-modal/use-change-announcement-modal.hook';

export const CareServicesPage = () => {
  usePageViewAnalytics({ screen_name: 'Care Services' });
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: 'STR_SERVICES' }));
  const { isAuthenticated } = useIsAuthenticated();

  const { shouldPresentModal, markModalAsSeen } = useChangeAnnouncementModal();
  const [isAnnouncementOpen, setIsAnnouncementOpen] = useState(false);
  const hasMarkedSeen = useRef(false);

  useEffect(() => {
    if (isAuthenticated && shouldPresentModal && !hasMarkedSeen.current) {
      hasMarkedSeen.current = true;
      setIsAnnouncementOpen(true);
      markModalAsSeen().catch((error) =>
        captureError(
          new Error(
            `Failed to mark change announcement modal as seen: ${error}`,
          ),
        ),
      );
    }
  }, [isAuthenticated, shouldPresentModal, markModalAsSeen]);

  return (
    <PageContentWrapper>
      <PageHeader
        headingText={formatMessage({ id: 'STR_SERVICES' })}
        showBackButton={isAuthenticated === false}
      />
      <Masonry rootNodeId={MASONRY.ROOT_NODE_ID_CARE_SERVICES} />
      {isAuthenticated && (
        <LiveChat liveChatAnalyticsContext="authenticatedCareServices" />
      )}
      <Modal.Root
        open={isAnnouncementOpen}
        onOpenChange={setIsAnnouncementOpen}
      >
        <ChangeAnnouncementModal />
      </Modal.Root>
    </PageContentWrapper>
  );
};
